import { ActionButton, Buttons, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import React from 'react';

function SaveToQuickBooksDialog({ invoice, resolve }) {
  const { workspace } = useWorkspace();
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const handleSubmit = async () => {
    form.submit();

    try {
      const { data } = await api.www.workspaces(workspace.id).invoices(invoice.id).saveToQuickBooks();
      await resolve();
      toast.success(`Invoice has been saved to QuickBooks with number #${data.invoice.number}.`);
    } catch (error) {
      toast.error(
        error.message ??
          'An error has occurred. The invoice has not been saved to QuickBooks. Please review the QuickBooks integration settings and try again.',
      );
      form.done();
    }
  };

  return (
    <ModalCard title="Save to QuickBooks" onClose={() => resolve(false)}>
      <ModalCard.Body>Are you sure you want to save this invoice to QuickBooks?</ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
            Save
          </ActionButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default SaveToQuickBooksDialog;
